window.addEventListener("load", () => {

  const sections = document.querySelectorAll(".top-concept");

  const observer = new IntersectionObserver((entries) => {

    entries.forEach(entry => {

      if (entry.isIntersecting) {
        entry.target.classList.add("show");
      } else {
        entry.target.classList.remove("show");
      }

    });

  }, {
    threshold: 0.5
  });

  sections.forEach(section => {
    observer.observe(section);
  });

});